module.exports = __webpack_public_path__ + "media/images/front/timeline/about_us_2017-66617ea2f033a0cb61d5a2cac8a32613.jpg";